
import De from 'crypto-js'
export default {
    install(Vue) {      
        Vue.prototype.$utils = {        
            enData: function (ciphertext) {                
                let str = De.DES.encrypt(ciphertext, De.enc.Utf8.parse('Url_key'), {
                    mode: De.mode.ECB,
                    padding: De.pad.Pkcs7
                }).toString()               
                return str
            },
            deData: function (ciphertext) {
                var keyHex = De.enc.Utf8.parse('Url_key');
                var ivHex = De.enc.Utf8.parse('Url_key');
                // direct decrypt ciphertext
                var decrypted = De.DES.decrypt({
                    ciphertext: De.enc.Base64.parse(ciphertext)
                }, keyHex, {
                    iv: ivHex,
                    mode: De.mode.ECB,
                    padding: De.pad.Pkcs7
                });
                return decrypted.toString(De.enc.Utf8);
            },
            // DeData: function (ciphertext) {
            //     var keyHex = De.enc.Utf8.parse(process.env.VUE_APP_ZLT_MMM);
            //     var ivHex = De.enc.Utf8.parse(process.env.VUE_APP_ZLT_MMM);
            //     // direct decrypt ciphertext
            //     var decrypted = De.DES.decrypt({
            //         ciphertext: De.enc.Base64.parse(ciphertext)
            //     }, keyHex, {
            //         iv: ivHex,
            //         mode: De.mode.ECB,
            //         padding: De.pad.Pkcs7
            //     });
            //     return decrypted.toString(De.enc.Utf8);
            // }
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/plugins.js